
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch, faXmark } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { formatCurrency, getCurrencySymbol, getRate } from '../utils/currencyUtils';
import { toast } from 'react-hot-toast';
import Modal from 'react-modal';
import logo from "../images/brand/logo.png";

function SignalCard({ signal_id, name, price}) {
    const { user } = useUser();
    const [error, setError] = useState(false);
    const [errorValue, setErrorValue] = useState();
    const [rate, setRate] = useState(1);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [disable, setDisable] = useState(true);
    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [signal_name, setSignal_name] = useState(name);
    const [signalAmount, setSignalAmount] = useState(price);

    useEffect(() => {
      if(signal_name && signalAmount){
        setDisable(false);
      }else{
        setDisable(true);
      }
    }, [signal_name, signalAmount]);

    const currencyCode = user?.currency;
    useEffect(() => {
      let isMounted = true;
      const fetchRate = async () => {
        const r = await getRate(currencyCode);
        if (isMounted) setRate(r);
      };
      fetchRate();
      return () => { isMounted = false; };
    }, [currencyCode]);
    const [amount, setAmount] = useState();
    const [loading, setLoading] = useState(false);
    const usdbal = user?.signal_balance * rate;
    
    const ValidateSignal = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/signal.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ btn_signal: true, signal_id: signal_id })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
            setTimeout(() => {
                window.location.href = "dashboard";
              }, 2000);
          }else{
            toast.error(data.message);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error(err)
          setLoading(false);
        })
    }

    const EditSignal = () =>{
      setLoading1(true);
      fetch(`${process.env.REACT_APP_API_URL}controller/signal.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ btn_editsignal: true, signal_id : signal_id, signal_name : signal_name, amount : signalAmount})
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          toast.success(data.result);
          setTimeout(() => {
            window.location.href = "signal";
          }, 2000);
        }else{
          toast.error(data.message);
        }
        setLoading1(false);
      })
      .catch(err => {
        console.error(err)
        setLoading1(false);
      })
    }
    const DeleteSignal = () =>{
      setLoading2(true);
      fetch(`${process.env.REACT_APP_API_URL}controller/signal.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ btn_deletesignal: true, signal_id : signal_id})
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          toast.success(data.result);
          setTimeout(() => {
            window.location.href = "signal";
          }, 2000);
        }else{
          toast.error(data.message);
        }
        setLoading2(false);
      })
      .catch(err => {
        console.error(err)
        setLoading2(false);
      })
    }

    return (
      <div className="mycard mb-4 position-relative">
        {user?.user_type === "adminface" && (
          <p className="text-prime fw-semibold position-absolute" onClick={() => setIsOpen(true)} style={{cursor: 'pointer', fontSize:'14px',top:'20px',right:'20px'}}>Edit</p>
        )}
        <img src={logo} alt="logo" className="mb-4" style={{width:'100px'}}/>
        <div className="d-flex align-items-center">
          <div className="p-0 rounded-circle d-flex align-items-center justify-content-center p-2" style={{width:'35px',height:'35px',backgroundColor:'#ffffff24'}}>
            <p className="mb-0 text-prime lh-1" style={{fontSize:'20px',fontWeight:'900'}}>{name.charAt(0).toUpperCase()}</p>
          </div>
          <p className="mb-0 ms-2" style={{fontWeight:'900'}}>{name}</p>
        </div>
        <div className="text-prime px-2 py-1 rounded-pill fw-bold d-inline-block mt-3 lh-1" style={{fontSize:'14px',backgroundColor:'#ff6b350a'}}>Amount</div>
        <p className="mb-0 text-success fw-bold" style={{fontSize:'40px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(price * rate)}</p>
        <div className={`myBtn text-center d-inline-block mt-4 px-5`} style={{paddingTop: '10px',paddingBottom: '10px'}} onClick={ValidateSignal}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Purchase'}</div>
        <img src="/uploads/Trading-in-Bull-Market-1-removebg-preview.png" alt="logo" className="position-absolute" style={{bottom:'40px', right:'5px', width:'170px',opacity:'0.5'}}/>
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => setIsOpen(false)}
            shouldCloseOnOverlayClick={true} 
            closeTimeoutMS={100}
            className="shortmode"
        >
          <div className="d-flex align-items-center justify-content-between">
              <p className="mb-0 fw-bold text-white" style={{fontSize: '16px'}}>Edit signal</p>
              <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
          </div>
          <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>Signal Name:</label>
          <div className="form-control py-2">
              <input 
                type="text"
                placeholder="Lite"
                className="inputNone"
                value={signal_name}
                onChange={(e) => setSignal_name(e.target.value)}
              />
          </div>
          <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Amount:</label>
          <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
              <input 
                type="number"
                placeholder="1000"
                className="inputNone"
                value={signalAmount}
                onChange={(e) => setSignalAmount(e.target.value)}
              />
              <div
                className="fw-bold text-white d-flex align-items-center"
                style={{
                  backgroundColor: 'rgb(30, 33, 36)',
                  borderRadius: '4px',
                  padding: '6px',
                  fontSize: '14px',
                  cursor: 'pointer' 
                }}
              >
                USD
              </div>
          </div>
          <div className="d-flex align-items- justify-content-between" style={{gap: '10px'}}>
            <div className={`myBtn w-100 text-center mt-3 bg-danger`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={DeleteSignal}>{loading2?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Delete'}</div>
            <div className={`myBtn w-100 text-center mt-3 bg-prime ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable ? EditSignal : null}>{loading1?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Save'}</div>
          </div>
        </Modal>
      </div>
    )
  }
  
  export default SignalCard